<template>
  <section class="list-filter-section">
    <div class="partners-filter-box list-box">
      <div class="filter-box-title">
        검색어 입력
        <input
          type="text"
          class="filter_input"
          v-model="search_text"
          v-on:keyup.enter="search_by_text"
        />
        <div class="filter_search" @click="search_by_text">
          <i class="fas fa-search "></i>
        </div>
      </div>
      <div
        class="selector-list"
        style="width: 1px; height: 1px;overflow:hidden; opaticy:0;margin:0px;"
      >
        <div class="selector-list-title">콘텐츠 분류</div>
        <div class="selector-item-list">
          <div
            class="selector-item"
            v-for="(cat, index) in content_filters"
            :key="'cat' + index"
          >
            <label class="control control--checkbox"
              >{{ cat.category }}
              <input
                type="checkbox"
                v-model="selected_content_filters"
                :value="cat.category"
              />
              <div class="control__indicator"></div>
            </label>
          </div>
        </div>
      </div>
      <div class="selector-list">
        <div class="selector-list-title">세부 카테고리</div>
        <div class="selector-item-list">
          <div class="selector-item">
            <div class="radio">
              <input
                :id="'det_cat' + 0"
                name="radio"
                type="radio"
                :value="all_id"
                v-model="select_detail_filter_id"
              />
              <label :for="'det_cat' + 0" class="radio-label">전체 </label>
            </div>
          </div>
          <div
            class="selector-item"
            v-for="(det_cat, index) in detail_content_filters"
            :key="'det_cat' + index"
          >
            <div class="radio">
              <input
                :id="'det_cat' + det_cat.id"
                name="radio"
                type="radio"
                :value="det_cat.id"
                v-model="select_detail_filter_id"
              />
              <label :for="'det_cat' + det_cat.id" class="radio-label">{{
                det_cat.category
              }}</label>
            </div>
          </div>
          <div class="selector-item" v-if="detail_content_filters.length == 0">
            <span class="help_text">세부 카테고리를 선택해 주세요</span>
          </div>
        </div>
      </div>
      <div>
        <select v-model="year">
          <option value="" selected>전체</option>
          <option value="2020">2020</option>
          <option value="2019">2019</option>
          <option value="2018">2018</option>
          <option value="2017">2017</option>
          <option value="2016">2016</option>
          <option value="2015">2015</option>
          <option value="2014">2014</option>
          <option value="2013">2013</option>
          <option value="2012">2012</option>
          <option value="2011">2011</option>
          <option value="2010">2010</option>
          <option value="2009">2009</option>
          <option value="2008">2008</option>
          <option value="2007">2007</option>
          <option value="2006">2006</option>
          <option value="2005">2005</option>
          <option value="2004">2004</option>
          <option value="2003">2003</option>
          <option value="2002">2002</option>
          <option value="2001">2001</option> </select
        >년
        <select v-model="month">
          <option value="" selected>전체</option>
          <option value="01">01</option>
          <option value="02">02</option>
          <option value="03">03</option>
          <option value="04">04</option>
          <option value="05">05</option>
          <option value="06">06</option>
          <option value="07">07</option>
          <option value="08">08</option>
          <option value="09">09</option>
          <option value="10">10</option>
          <option value="11">11</option>
          <option value="12">12</option> </select
        >월
      </div>
    </div>
    <div class="apply-request-helper"></div>
  </section>
</template>
<script>
import EventBus from "@/EventBus.js";
export default {
  data() {
    return {
      selected_content_filters: [],
      selected_detail_content_filters: [],
      detail_content_filters: [],
      search_text: "",
      content_filters: [],
      year: "",
      month: "",
      det_cat_all: true,
      all_id: "",
      select_detail_filter_id: ""
    };
  },
  watch: {
    det_cat_all(to, from) {},
    year(to, from) {  
      console.log("...")    
      console.log(to)
      console.log(from)
      EventBus.$emit("change_year", this.year);
    },
    month(to, from) {
      EventBus.$emit("change_month", this.month);
    },
    selected_content_filters(new_val, old_val) {
      this.detail_content_filters = [];
      this.selected_detail_content_filters = [];
      new_val.forEach(element => {
        console.log(new_val);
        this.detail_content_filters = this.detail_content_filters.concat(
          this.content_filters.find(x => x.category == element).sub_category
        );
        let id_list = [];
        for (let k = 0; k < this.detail_content_filters.length; k++) {
          id_list.push(this.detail_content_filters[k].id);
        }
        this.all_id = id_list.join(",");

        if (this.$route.query.id_list === undefined || this.$route.query.id_list=="" ) {
          this.select_detail_filter_id = this.all_id;
          EventBus.$emit("get_content", this.all_id);
        } else {
          this.select_detail_filter_id = this.$route.query.id_list;
        }

      });
    },
    select_detail_filter_id(new_val, old_val) {
      EventBus.$emit("get_content", new_val);
    },
    selected_local_filters() {},
    selected_cert_filters() {},
    $route(to, from) {
      this.$http.get("app/get_content_filter").then(res => {
        console.log(res);
        this.content_filters = res.data.result;
     

        this.$nextTick(() => {
          this.selected_content_filters = [];
          if (to.query.content == "popsign") {
            this.selected_content_filters.push("월간 팝사인");
          } else if (to.query.content == "textile") {
            this.selected_content_filters.push("월간 텍스타일");
          }
        });
      });
    }
  },
  methods: {
    check_to_radio(target_obj) {
      console.log(target_obj);
      this.selected_detail_content_filters = JSON.parse(
        JSON.stringify(target_obj)
      );
      console.log(this.selected_detail_content_filters);
      EventBus.$emit("get_content", target_obj.id);
    },
    search_by_text() {
      EventBus.$emit("search_by_text", this.search_text);
    }
  },
  created() {
    this.year = this.$route.query.year
    this.month = this.$route.query.month
    this.$http.get("app/get_content_filter").then(res => {
      console.log(res);
      this.content_filters = res.data.result;
      this.$nextTick(() => {
        if (this.$route.query.content == "popsign") {
          this.selected_content_filters.push("월간 팝사인");
        } else if (this.$route.query.content == "textile") {
          this.selected_content_filters.push("월간 텍스타일");
        }
      });
    });
  }
};
</script>

<style scoped lang="scss">
$color1: #f4f4f4;
$color2: #3197ee;

.list-filter-section {
  width: 200px;
  float: left;
  .list-box {
    *zoom: 1;
    background-color: #ffffff;
    border-radius: 2px;
    box-shadow: 0 1px 0 0 #dedede;
    border: 1px solid #dedede;
    padding: 16px;
    .filter-box-title {
      position: relative;
      font-size: 14px;
      font-weight: bold;
      color: #333333;
      padding: 0 4px 12px 4px;
      border-bottom: 1px solid #dedede;
      margin-bottom: 12px;
    }
    .selector-list {
      padding: 0 4px;
      margin: 0 0 16px 0;
      .help_text {
        font-size: 14px;
        color: #666;
      }
      .selector-list-title {
        font-size: 14px;
        font-weight: bold;
        color: #555555;
      }
      .selector-item-list {
        margin: 5px 0 10px 0;
        input {
          margin: 0;
        }
        label {
          display: inline-block;
          font-size: 12px;
          font-weight: normal;
          color: #555555;
          margin: 0 0 0 10px;
        }
      }
    }
  }
  .apply-request-helper {
    margin-top: 6px;
    cursor: pointer;
    font-weight: bold;
  }
  .filter_input {
    width: 100%;
    padding: 2px 3px;
    font-size: 14px;
    color: #696969;
    margin-top: 5px;
  }
  .filter_search {
    position: absolute;
    top: 34px;
    right: 10px;
    color: #888484;
    cursor: pointer;
  }
  .control {
    font-size: 18px;
    position: relative;
    display: block;
    margin-bottom: 15px;
    padding-left: 30px;
    cursor: pointer;
  }

  .control input {
    position: absolute;
    z-index: -1;
    opacity: 0;
  }
  .control__indicator {
    position: absolute;
    top: 2px;
    left: 0;
    width: 17px;
    height: 17px;
    background: #e6e6e6;
  }

  .control--radio .control__indicator {
    border-radius: 50%;
  }
  /* Hover and focus states */
  .control:hover input ~ .control__indicator,
  .control input:focus ~ .control__indicator {
    background: #ccc;
  }

  /* Checked state */
  .control input:checked ~ .control__indicator {
    background: #2aa1c0;
  }

  /* Hover state whilst checked */
  .control:hover input:not([disabled]):checked ~ .control__indicator,
  .control input:checked:focus ~ .control__indicator {
    background: #2aa1c0;
  }

  .control.all input:checked ~ .control__indicator {
    background: #e6e6e6 !important;
  }
  /* Check mark */
  .control__indicator:after {
    position: absolute;
    display: none;
    content: "";
  }

  /* Show check mark */
  .control input:checked ~ .control__indicator:after {
    display: block;
  }

  /* Checkbox tick */
  .control--checkbox .control__indicator:after {
    top: 2px;
    left: 5px;
    width: 7px;
    height: 10px;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
    border: solid #fff;
    border-width: 0px 3px 3px 0;
  }
  .control--checkbox.all .control__indicator:after {
    top: 2px;
    left: 5px;
    width: 7px;
    height: 10px;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
    border: solid #e6e6e6;
    border-width: 0px 3px 3px 0;
  }
}

.radio {

  input[type="radio"] {
    position: absolute;
    opacity: 0;
    + .radio-label {
      &:before {
        content: "";
        background: $color1;
        border-radius: 100%;
        border: 1px solid darken($color1, 25%);
        display: inline-block;
        width: 1.4em;
        height: 1.4em;
        position: relative;
        top: 0em;
        margin-right: 1em;
        vertical-align: top;
        cursor: pointer;
        text-align: center;
        transition: all 250ms ease;
      }
    }
    &:checked {
      + .radio-label {
        &:before {
          background-color: $color2;
          box-shadow: inset 0 0 0 4px $color1;
        }
      }
    }
    &:focus {
      + .radio-label {
        &:before {
          outline: none;
          border-color: $color2;
        }
      }
    }
    &:disabled {
      + .radio-label {
        &:before {
          box-shadow: inset 0 0 0 4px $color1;
          border-color: darken($color1, 25%);
          background: darken($color1, 25%);
        }
      }
    }
    + .radio-label {
      cursor: pointer;
      &:empty {
        &:before {
          margin-right: 0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/SPA/PopconContent/Components/ContentsListFilter.vue